// Quem theme JS — drives the ticker, category slider and gift-finder wizard.
// All content comes from the section markup / Customizer, so this file
// never needs editing when a merchant changes copy.

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- In-page anchor smooth scroll ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id && id.length > 1) {
        var el = document.querySelector(id);
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  });

  /* ---------- Trusted Clients ticker (duplicate marks for seamless loop) ---------- */
  document.querySelectorAll('.ticker-track').forEach(function (track) {
    if (track.dataset.looped === '1') return;
    track.innerHTML = track.innerHTML + track.innerHTML;
    track.dataset.looped = '1';
  });

  /* ---------- Category slider: infinite loop on tablet/mobile ---------- */
  document.querySelectorAll('.occ-rail').forEach(function (rail) {
    var scroller = rail.querySelector('.occasions');
    var prev = rail.querySelector('.occ-arrow--prev');
    var next = rail.querySelector('.occ-arrow--next');
    if (!scroller || !prev || !next) return;

    var originals = Array.prototype.slice.call(scroller.children);
    var cloned = false;

    function isCarousel() { return getComputedStyle(scroller).display === 'flex'; }
    function step() {
      var card = scroller.querySelector('.occ-card');
      if (!card) return 240;
      var styles = getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap || styles.gap || '14') || 14;
      return card.getBoundingClientRect().width + gap;
    }
    function originalWidth() { return step() * originals.length; }
    function ensureClones() {
      var want = isCarousel();
      if (want && !cloned) {
        originals.forEach(function (el) {
          var c = el.cloneNode(true);
          c.classList.add('occ-clone');
          c.setAttribute('aria-hidden', 'true');
          scroller.appendChild(c);
        });
        cloned = true;
      } else if (!want && cloned) {
        scroller.querySelectorAll('.occ-clone').forEach(function (c) { c.remove(); });
        cloned = false;
        scroller.scrollLeft = 0;
      }
    }
    function onScroll() {
      if (!isCarousel() || !cloned) return;
      var w = originalWidth();
      if (w > 0 && scroller.scrollLeft >= w) scroller.scrollLeft -= w;
    }
    function go(dir) {
      if (!isCarousel()) return;
      if (dir < 0 && scroller.scrollLeft < 1) scroller.scrollLeft = originalWidth();
      scroller.scrollBy({ left: step() * dir, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', ensureClones);
    ensureClones();
  });

  /* ---------- Gift-Finder wizard (data-driven from section markup) ---------- */
  document.querySelectorAll('.wizard-card').forEach(function (wizCard) {
    var groups   = Array.prototype.slice.call(wizCard.querySelectorAll('.wiz-options'));
    if (!groups.length) return;
    var backBtn  = wizCard.querySelector('.wiz-back');
    var nextBtn  = wizCard.querySelector('.wiz-next');
    var sendBtn  = wizCard.querySelector('.wiz-send');
    var stepLab  = wizCard.querySelector('.wiz-step-label');
    var barFill  = wizCard.querySelector('.wiz-bar-fill');
    var sumList  = wizCard.querySelector('.wiz-summary-list');
    var nameIn   = wizCard.querySelector('.wiz-name');
    var waIn     = wizCard.querySelector('.wiz-whatsapp');
    var compIn   = wizCard.querySelector('.wiz-company');
    var doneStep = wizCard.querySelector('.wiz-done');
    var form     = wizCard.querySelector('.wiz-contact-form');
    var steps    = Array.prototype.slice.call(wizCard.querySelectorAll('.wiz-step'));

    var TOTAL = groups.length;       // number of question steps
    var FINAL = TOTAL + 1;           // the contact step
    var waNumber = (wizCard.dataset.whatsapp || '').replace(/[^0-9]/g, '');
    var mode = wizCard.dataset.submit || 'whatsapp'; // 'whatsapp' | 'message'

    // Build label + order from the markup (data-key / data-label on each group)
    var order = groups.map(function (g) { return g.dataset.key; });
    var labels = {};
    groups.forEach(function (g) { labels[g.dataset.key] = g.dataset.label || g.dataset.key; });

    var answers = {};
    var current = 1;

    function decode(s) {
      var ta = document.createElement('textarea');
      ta.innerHTML = s || '';
      return ta.value;
    }
    function show(n, opts) {
      current = n;
      steps.forEach(function (s) { s.classList.toggle('is-active', Number(s.dataset.step) === n); });
      if (n <= TOTAL) {
        stepLab.textContent = 'Question ' + n + ' of ' + TOTAL;
        barFill.style.width = (n / TOTAL * 100) + '%';
        nextBtn.style.display = 'inline-flex';
        var stepEl = wizCard.querySelector('.wiz-step[data-step="' + n + '"]');
        var key = stepEl.querySelector('.wiz-options').dataset.key;
        nextBtn.disabled = !answers[key];
      } else {
        stepLab.textContent = 'Almost done — your details';
        barFill.style.width = '100%';
        nextBtn.style.display = 'none';
        populateSummary();
        validateContact();
      }
      backBtn.disabled = (n === 1);
      if (opts && opts.scroll) wizCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function populateSummary() {
      if (!sumList) return;
      sumList.innerHTML = order.map(function (k) {
        return '<li><span>' + labels[k] + '</span><span>' + (answers[k] || '—') + '</span></li>';
      }).join('');
    }
    function validateContact() {
      if (!sendBtn) return;
      var ok = nameIn.value.trim().length > 0 && waIn.value.trim().length >= 8;
      sendBtn.disabled = !ok;
    }

    groups.forEach(function (group) {
      var key = group.dataset.key;
      group.querySelectorAll('.wiz-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.wiz-option').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          answers[key] = decode(btn.dataset.value);
          nextBtn.disabled = false;
        });
      });
    });

    nextBtn.addEventListener('click', function () { if (current < FINAL) show(current + 1, { scroll: true }); });
    backBtn.addEventListener('click', function () { if (current > 1) show(current - 1, { scroll: true }); });
    [nameIn, waIn].forEach(function (inp) { if (inp) inp.addEventListener('input', validateContact); });

    if (sendBtn) {
      sendBtn.addEventListener('click', function () {
        var name = nameIn.value.trim();
        var company = compIn ? compIn.value.trim() : '';
        var whatsapp = waIn.value.trim();
        var lines = ['Hi 👋', '', "Here's my gift brief:"];
        order.forEach(function (k) { lines.push('• ' + labels[k] + ': ' + (answers[k] || '—')); });
        lines.push('', 'My details:', '• Name: ' + name, '• Company: ' + (company || '—'), '• WhatsApp: ' + whatsapp);

        if (mode === 'whatsapp' && waNumber) {
          var url = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(lines.join('\n'));
          window.open(url, '_blank', 'noopener');
        }
        // Show the on-screen thank-you either way
        if (doneStep) {
          if (form) form.style.display = 'none';
          doneStep.style.display = 'block';
          doneStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    show(1);
  });
});

/* =================================================================
   QUEM v2 — Header nav, sidebar, search overlay, events tabs
   ================================================================= */
document.addEventListener('DOMContentLoaded', function () {

  /* --- Topbar marquee --- */
  document.querySelectorAll('.q-topbar-track').forEach(function (t) {
    if (t.dataset.looped === '1') return;
    t.innerHTML += t.innerHTML;
    t.dataset.looped = '1';
  });

  /* --- Mega menu --- */
  (function () {
    var zone = document.getElementById('qNavzone');
    if (!zone) return;
    var items = Array.from(zone.querySelectorAll('.q-nav-item[data-mega]'));
    var timer = null;
    function open(key) {
      clearTimeout(timer);
      items.forEach(function (it) { it.classList.toggle('is-open', it.dataset.mega === key); });
      zone.querySelectorAll('.q-mega').forEach(function (m) { m.classList.toggle('is-open', m.id === 'q-mega-' + key); });
    }
    function close() {
      items.forEach(function (it) { it.classList.remove('is-open'); });
      zone.querySelectorAll('.q-mega').forEach(function (m) { m.classList.remove('is-open'); });
    }
    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () { open(it.dataset.mega); });
      var btn = it.querySelector('.q-nav-link');
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        it.classList.contains('is-open') ? close() : open(it.dataset.mega);
      });
    });
    zone.addEventListener('mouseleave', function () { timer = setTimeout(close, 140); });
    zone.addEventListener('mouseenter', function () { clearTimeout(timer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* --- Mobile sidebar --- */
  (function () {
    var sidebar  = document.getElementById('qMobSidebar');
    var backdrop = document.getElementById('qMobBackdrop');
    var openBtn  = document.getElementById('qHamburgerBtn');
    var closeBtn = document.getElementById('qMobClose');
    if (!sidebar || !openBtn) return;
    function openSidebar()  { sidebar.classList.add('is-open'); backdrop.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeSidebar() { sidebar.classList.remove('is-open'); backdrop.classList.remove('is-open'); document.body.style.overflow = ''; }
    openBtn.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
    backdrop.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSidebar(); });
    sidebar.querySelectorAll('[data-mob-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.q-mob-item');
        var wasOpen = item.classList.contains('is-open');
        sidebar.querySelectorAll('.q-mob-item').forEach(function (it) { it.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  })();

  /* --- Search overlay --- */
  (function () {
    var overlay  = document.getElementById('qSearchOverlay');
    var backdrop = document.getElementById('qSearchBackdrop');
    var openBtn  = document.getElementById('qSearchBtn');
    var closeBtn = document.getElementById('qSearchClose');
    var input    = document.getElementById('qSearchInput');
    if (!overlay || !openBtn) return;
    function openSearch()  {
      overlay.classList.add('is-open'); backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 80);
    }
    function closeSearch() { overlay.classList.remove('is-open'); backdrop.classList.remove('is-open'); document.body.style.overflow = ''; }
    openBtn.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    backdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
  })();

  /* --- Events tabs --- */
  (function () {
    var tabs = document.querySelectorAll('.events-tab');
    var sec  = document.querySelector('.events-sec');
    if (!sec || !tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        sec.querySelectorAll('.events-panel').forEach(function (p) { p.style.display = 'none'; });
        var panel = document.getElementById('q-tab-' + tab.dataset.tab);
        if (panel) panel.style.display = 'block';
      });
    });
  })();

  /* --- Cart badge (live count) --- */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var badge = document.getElementById('qCartBadge');
    if (!badge) return;
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
  }).catch(function () {});

});
